import { ProgressiveCertificationsDataStore } from '../datastores/ProgressiveCertificationsDataStore';
import { ProgressiveCertificationsDataStoreFactory } from '../factories/ProgressiveCertificationsFactory';

export default class ProgressiveCertificationsDataRepository {
  getProgressiveCertifications(carrer: string, prog: string, acadPlan: string) {
    const progressiveCertificationsDataStore: ProgressiveCertificationsDataStore =
      ProgressiveCertificationsDataStoreFactory.create();
    return progressiveCertificationsDataStore.getProgressiveCertifications(
      carrer,
      prog,
      acadPlan
    );
  }
}
